import { env } from '~/env'

const baseUrl = env.VITE_PUBLIC_APP_URL.replace(/\/$/, '')

export function getEventShareUrl(eventId: string): string {
  return `${baseUrl}/events/${eventId}`
}

export function getListingShareUrl(listingId: string): string {
  return `${baseUrl}/listings/${listingId}`
}

export async function copyToClipboard(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch {
    return false
  }
}
